module.exports = __webpack_public_path__ + "img/fix-bigo.396dff.png";